import NightingaleChart from "../../../Components/Charts/RetailNightingleChart";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark";

const finacier_retails = async (body) => {
  try {
    const res = await axInst.post("retails/finacier-retails", body);
    return res.data.financier_based_count;
  } catch (error) {
    console.error(error);
  }
};

const Top5finance = () => {
  const { data, submitted } = useSelector((e) => e.filters);

  const {
    data: top5finance,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["top5finance", submitted],
    queryFn: () => finacier_retails(data),
    cacheTime: 0,
    staleTime: 0,
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });
  return (
    <div className="relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {!isFetching && !isError && (
        <div>
          <NightingaleChart
            data={top5finance}
            heading="Top 5 Finaciers"
            h="230"
          />
        </div>
      )}
    </div>
  );
};
export default Top5finance;
